// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import GlobalStyles from '../../config/styles';

const CIRCLE_RADIUS = 44;

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    zIndex: 1,
  },
  dateTimeContainer: {
    marginTop: 5,
    marginBottom: 5,
    minWidth: 84,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.down(649)]: {
      display: 'none',
    },
  },
  dateTimeText: {
    margin: 0,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
  },
  imageContainer: {
    position: 'relative',

    [theme.breakpoints.down(649)]: {
      display: 'none',
    },
  },
  imageInnerContainer: {
    display: 'flex',
    borderRadius: 25,
    width: CIRCLE_RADIUS,
    height: CIRCLE_RADIUS,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
  },
  image: {
    width: 24,
  },
  infoContainer: {
    maxWidth: 524,
    width: '100%',
    borderRadius: 16,
    padding: '12px 16px 6px',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    marginBottom: 20,
    marginLeft: 5,

    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 6,

    [theme.breakpoints.down(376)]: {
      flexDirection: 'column',
    },
  },
  text: {
    margin: 0,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,

    [theme.breakpoints.down(549)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  descText: {
    margin: 0,
    textTransform: 'uppercase',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GRAY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,

    [theme.breakpoints.down(549)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  line: {
    position: 'absolute',
    top: 0,
    left: '50%',
    right: '50%',
    bottom: 0,
    width: 2,
    height: '100%',
    backgroundColor: GlobalStyles.color.COLOR_SECONDARY,
    zIndex: -1,
  },
  mobileDateContainer: {
    display: 'none',

    [theme.breakpoints.down(649)]: {
      display: 'flex',
    },
  },
  redeemContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 4,
    marginBottom: 6,
  },
  redeemButton: {
    minWidth: 110,
    padding: '6px 18px',
    borderRadius: 40,
    border: 'none',
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_PRIMARY,
    background: 'linear-gradient(180deg, rgba(91,220,255,1) 0%, rgba(60,170,236,1) 100%)',
    '&:hover': {
      opacity: 0.5,
    },
    '&:focus': {
      outline: 'none',
    },
  },
  redeemButtonDisabled: {
    background: GlobalStyles.color.COLOR_DEFAULT,
    color: GlobalStyles.color.COLOR_GRAY,
    cursor: 'not-allowed',
    '&:hover': {
      opacity: 1,
    },
  },
});

export default styles;
